import { AuthedPage } from "pages/AuthedPage";
import { useRouter } from "next/router";
import { useApplicationContext } from "src/hooks/useApplication";

import { useDocumentTitle } from "src/hooks/useDocumentTitle";
import { theme } from "antd";
import { useEffect, useMemo } from "react";

import { useColorScheme } from "src/hooks/useColorScheme";
import { TopicFeedWrapper } from "./topics/components/TopicFeed";
import { CssVars } from "src/components/CssVars";
import styles from "./home.module.css";
import { HomeOutlined } from "@ant-design/icons";

type FeedConfigType = {
  defaultSize?: "mini" | "expanded";
  availableSizes?: Array<"mini" | "expanded">;
  showSizeSelector?: boolean;
  enableCardClick?: boolean;
  defaultLayout?: "list";
  availableLayouts?: Array<"list">;
  showLayoutSelector?: boolean;
};

export function NewHome() {
  const { org_name, setTitle } = useApplicationContext();

  const feedConfig = useMemo<FeedConfigType>(
    () => ({
      defaultSize: "mini",
      availableSizes: ["mini", "expanded"],
      showSizeSelector: false,
      enableCardClick: true,
      defaultLayout: "list",
      showLayoutSelector: false,
    }),
    []
  );

  // Move setTitle into useEffect
  useEffect(() => {
    setTitle(`${org_name} - Home`);
  }, [org_name, setTitle]);

  return (
    <CssVars>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <div
          className={styles.section}
          style={{
            flex: 1,
            minHeight: 0,
            width: "100%",
          }}
        >
          <TopicFeedWrapper config={feedConfig} />
        </div>
      </div>
    </CssVars>
  );
}

export default function HomeV2Page() {
  useDocumentTitle("VZBL Home");
  return <AuthedPage orgId title="Home" main={() => <NewHome />} />;
}
